import { UNISWAP_FEE_TIER } from './feeTier'

export const UNISWAP_TICK_SPACING: { [key in UNISWAP_FEE_TIER]: number } = {
  [UNISWAP_FEE_TIER.ONE_HUNDRED]: 1,
  [UNISWAP_FEE_TIER.FIVE_HUNDRED]: 10,
  [UNISWAP_FEE_TIER.THREE_THOUSAND]: 60,
  [UNISWAP_FEE_TIER.TEN_THOUSAND]: 200,
}
